/**
 * Logging control for search document builders.
 *
 * In bulk load mode, per-document debug logging is suppressed to avoid
 * flooding CloudWatch with millions of log entries. Error logging is always on.
 *
 * Usage:
 *   import { searchBuilderLog } from "@tc/search-document-builders"
 *   searchBuilderLog.silent = true  // suppress debug logs (bulk load)
 *   searchBuilderLog.silent = false // normal logging (SQS pipeline, default)
 */

let _silent = false

export const searchBuilderLog = {
  get silent() {
    return _silent
  },
  set silent(value: boolean) {
    _silent = value
  },
  debug: (...args: unknown[]) => {
    if (!_silent) console.debug(...args)
  },
  error: (...args: unknown[]) => {
    console.error(...args)
  },
  info: (...args: unknown[]) => {
    if (!_silent) console.info(...args)
  },
  warn: (...args: unknown[]) => {
    console.warn(...args)
  },
}
